export default {
    data() {
        return {
            labels: {
                id: '0'
            },
            arr: [],
            // 标签数组
            labelList: []
        }
    },
    methods: {
        //获取类别标签
        getLabel() {
            this.$post('labels/all', { shop_id: 1 }).then(res => {
                this.arr = []
                let data = res.data.result;
                this.labels = { id: 0 }
                this.allLabel(data, this.labels);
                this.intercept();
            })
        },

        //递归处理返回的标签
        allLabel(data, labelObj) {
            for (let i in data) {
                if (data[i].parent_id == labelObj.id) {
                    if (!labelObj.children) {
                        labelObj.children = [];
                    }
                    labelObj.children.push(data[i]);
                    this.allLabel(data, data[i]);
                }
            }
        },

        //获取
        intercept() {
            let obj = this.labels.children
            this.arr = obj;
            // console.log(this.arr)
        },

        // 选择标签
        selectNode(label) {
            this.labelList.push(label)
        },

        // 确认选择
        submit() {
            for (let i = 0; i < this.labelList.length; i++) {
                this.$post('labels/create', {
                    parent_id: this.labelList[i].parent_id,
                    name: this.labelList[i].name,
                    onsale: 1,
                    shop_id: this.$store.state.store.id,
                    token: this.$store.state.authority_management,
                }).then(res => {

                })
            }
            this.$message({
                type: 'success',
                message: '添加标签成功'
            })
        }

    },
    created() {
        // 获取标签
        this.getLabel()
    },
}